import React from 'react';
import { Title } from 'app/blocks/blocks';
import { ID, withCodes } from 'app/blocks/common/codes';
import SvgIcon from 'app/blocks/common/svg-icon/svg-icon';

function MissingArticleSubmitSuccess(props) {
    const { codes } = props;
    const search = codes.SEARCH_CODES.SEARCH.MISSING_ARTICLE_SUBMIT;

    return (
        <div className="MissingArticleDetails-FormContent" data-seleniumid="missing-article-details-success">
            <Title>
                <SvgIcon.schedule className="MissingArticleDetails-SuccessIcon" />

                {search.title}
            </Title>
            <div
                className="MissingArticleDetails-SuccessWrapper"
                dangerouslySetInnerHTML={{ __html: search.description }}
            />
        </div>
    );
}

export default withCodes(MissingArticleSubmitSuccess, ID.SEARCH_CODES);
